module.exports = __webpack_public_path__ + "static/img/pan-inner-month-1112.c406b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/rotate/pan-inner-month-1112.png
// module id = HS2M
// module chunks = 1